/**
 * IT support request topics for VIVA HUB staff form
 */

export const HUB_SUPPORT_EMAIL = 'support@vivapsychotherapy.com'

export const HUB_SUPPORT_CATEGORIES = [
  { value: 'google_workspace', label: 'Google Workspace account' },
  { value: 'email', label: 'Email' },
  { value: 'password_access', label: 'Password and accessing' },
  { value: 'permissions', label: 'Permissions' },
  { value: 'viva_hub', label: 'VIVA HUB' },
  { value: 'room_scheduler', label: 'Room Scheduler' },
  { value: 'viva_crm', label: 'VIVA CRM' },
  { value: 'software_license', label: 'Request software license' },
  { value: 'printer', label: 'Printer' },
  { value: 'wifi', label: 'Wi‑Fi' },
  { value: 'other', label: 'Other IT / technical support' },
]

export const HUB_SUPPORT_CATEGORY_VALUES = HUB_SUPPORT_CATEGORIES.map((c) => c.value)

export function hubSupportCategoryLabel (value) {
  return HUB_SUPPORT_CATEGORIES.find((c) => c.value === value)?.label || value
}
